import { useQuery } from '@tanstack/react-query';
import { getDocs, orderBy, query } from 'firebase/firestore';

import { useAuth } from '@/app/auth';
import { unknownSensorsCollection } from '@/lib/firestorePaths';

import type { UnknownSensor } from '../types/unknownSensor';

const STALE_TIME_MS = 30_000;
const REFETCH_INTERVAL_MS = 60_000;

export default function useUnknownSensors(homeId: string | undefined) {
  const { status } = useAuth();
  const enabled = status === 'authorized' && !!homeId;

  return useQuery<UnknownSensor[]>({
    queryKey: ['homeAutomation', 'unknownSensors', homeId ?? null],
    queryFn: async () => {
      const snap = await getDocs(query(unknownSensorsCollection(homeId!), orderBy('lastSeenAt', 'desc')));
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    },
    enabled,
    staleTime: STALE_TIME_MS,
    refetchInterval: enabled ? REFETCH_INTERVAL_MS : false,
  });
}
